import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { brandConfig } from "../../../config/brand";
import { PublicFooter } from "./PublicFooter";
import { PublicHeader } from "./PublicHeader";

export function AppShell({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith("/admin");
  const isReportRenderRoute = pathname.startsWith("/report-render/");

  if (isAdminRoute) {
    return <div className="min-h-screen w-full bg-slate-950 text-white">{children}</div>;
  }

  if (isReportRenderRoute) {
    return (
      <div className="relative min-h-screen overflow-x-hidden bg-slate-950 text-white">
        <header className="border-b border-cyan-200/10 bg-slate-950">
          <div className="mx-auto flex min-h-16 w-full max-w-6xl items-center gap-3 px-4 sm:px-6">
            <img src={brandConfig.logoMarkPath} alt="" className="h-9 w-9 shrink-0 object-contain" />
            <span className="truncate text-base font-bold tracking-normal">{brandConfig.brandName}</span>
          </div>
        </header>
        <main>{children}</main>
      </div>
    );
  }

  return (
    <div className="relative flex min-h-screen flex-col overflow-x-hidden">
      <PublicHeader />
      <main className="flex-1">{children}</main>
      <PublicFooter />
    </div>
  );
}
